import spacing from './spacing';
import typography from './typography';
import colors from './colors';
import breakpoints from './breakpoints';
import rems from './utils/rems';
import { visuallyHidden, notVisuallyHidden } from './utils/visuallyHidden';

export default {
  ...spacing,
  ...typography,
  ...colors,
  ...breakpoints,
  boxShadowBase: '0 3px 5px 0 rgba(0, 0, 0, 0.1)',
  boxShadowMobileBase: '0 10px 20px 0 rgba(0, 0, 0, 0.1)',
  boxShadowCard: '0 2px 10px 0 rgba(0, 0, 0, 0.2)',
  boxShadowCardRaised: '0 5px 23px 3px rgba(0, 0, 0, 0.2)',
  transitionTime: '0.2s',
  transitionEasing: 'cubic-bezier(0.77, 0, 0.175, 1)',
};

export { rems, visuallyHidden, notVisuallyHidden };
